import type {
  AlertStatus,
  NotificationSeverity,
  NotificationType,
} from "@situate/contracts/firestore";

/** Sentinel Select value representing "no filter applied" (shows every notification). */
export const ALL_FILTER_VALUE = "all";

export interface FilterOption<T extends string> {
  value: T | typeof ALL_FILTER_VALUE;
  label: string;
}

export const SEVERITY_FILTER_OPTIONS: FilterOption<NotificationSeverity>[] = [
  { value: ALL_FILTER_VALUE, label: "All Severities" },
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "warning", label: "Warning" },
  { value: "info", label: "Info" },
];

export const NOTIFICATION_TYPE_FILTER_OPTIONS: FilterOption<NotificationType>[] = [
  { value: ALL_FILTER_VALUE, label: "All Types" },
  { value: "alert", label: "Alert" },
  { value: "system", label: "System" },
];

export const LIFECYCLE_FILTER_OPTIONS: FilterOption<AlertStatus>[] = [
  { value: ALL_FILTER_VALUE, label: "All Statuses" },
  { value: "active", label: "Active" },
  { value: "resolved", label: "Resolved" },
];
